export default __webpack_public_path__ + "static/media/blog-img93.49e13e14.jpg";